import axios from 'axios';
import BaseUrl from '../../utils/api.js';

export default class RealTimeService {


    static getRealTime() {
        //var data = [];
        return axios.get(`${BaseUrl}RealTimeLog`);
    }


}


// WEBPACK FOOTER //
// ./src/Services/RealTimeService/realtimeService.js